import { render } from "./SelectSocialCauses.vue?vue&type=template&id=de2d5a8a&scoped=true"
import script from "./SelectSocialCauses.vue?vue&type=script&lang=js"
export * from "./SelectSocialCauses.vue?vue&type=script&lang=js"

import "@/Common/Styles/selectSocialCauses.scss?vue&type=style&index=0&id=de2d5a8a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2d5a8a"]])

export default __exports__